import { REQUIRED_FIELD, ONLY_NUMBER, INVALID_FIELD } from '@/utils/validationMessagesUtils'

export default {
  isInteriorErrors () {
    const errors = []
    if (!this.$v.item.jsonFlags.isInterior.$dirty) return errors
    !this.$v.item.jsonFlags.isInterior.required && errors.push(REQUIRED_FIELD)
    return errors
  },

  isResetBalance () {
    const errors = []
    if (!this.$v.item.jsonFlags.isResetBalance.$dirty) return errors
    !this.$v.item.jsonFlags.isResetBalance.required && errors.push(REQUIRED_FIELD)
    return errors
  },

  institutionParentIdErrors () {
    const errors = []
    if (!this.$v.item.parentId.$dirty) return errors
    !this.$v.item.parentId.required && errors.push('Seleção da OSC é obrigatório.')
    return errors
  },

  institutionCodErrors () {
    const errors = []
    if (!this.$v.item.cod.$dirty) return errors
    !this.$v.item.cod.required && errors.push(REQUIRED_FIELD)
    !this.$v.item.cod.isOnlyNumber && errors.push(ONLY_NUMBER)
    return errors
  },

  institutionNameErrors () {
    const errors = []
    if (!this.$v.item.name.$dirty) return errors
    !this.$v.item.name.required && errors.push('Nome é obrigatório.')
    return errors
  },

  institutionEmailErrors () {
    const errors = []
    if (!this.$v.item.email.$dirty) return errors
    !this.$v.item.email.required && errors.push('Email é obrigatório.')
    !this.$v.item.email.email && errors.push('Por favor, digitar um email válido.')
    return errors
  },

  institutionCnpjErrors () {
    const errors = []
    if (!this.$v.item.cnpj.$dirty) return errors
    !this.$v.item.cnpj.required && errors.push('CNPJ é obrigatório.')
    return errors
  },

  institutionDocumentErrors () {
    const errors = []
    if (!this.$v.item.document.$dirty) return errors
    !this.$v.item.document.required && errors.push(REQUIRED_FIELD)
    !this.$v.item.document.isValidCpfOrCnpj && errors.push(INVALID_FIELD)
    return errors
  },

  institutionAddressErrors () {
    const errors = []
    if (!this.$v.item.address.$dirty) return errors
    !this.$v.item.address.required && errors.push('Endereço é obrigatório.')
    return errors
  },

  institutionPhoneErrors () {
    const errors = []
    if (!this.$v.item.phone.$dirty) return errors
    !this.$v.item.phone.required && errors.push(REQUIRED_FIELD)
    !this.$v.item.phone.minLength && errors.push(INVALID_FIELD)
    return errors
  },

  institutionCepErrors () {
    const errors = []
    if (!this.$v.item.cep.$dirty) return errors
    !this.$v.item.cep.required && errors.push('CEP é obrigatório.')
    !this.$v.item.cep.minLength && errors.push('Por favor, digitar um número de CEP válido.')
    return errors
  },

  institutionCityErrors () {
    const errors = []
    if (!this.$v.item.city.$dirty) return errors
    !this.$v.item.city.required && errors.push('Cidade é obrigatório.')
    return errors
  },

  institutionStateErrors () {
    const errors = []
    if (!this.$v.item.state.$dirty) return errors
    !this.$v.item.state.required && errors.push('Estado é obrigatório.')
    return errors
  },

  institutionNeighborhoodErrors () {
    const errors = []
    if (!this.$v.item.neighborhood.$dirty) return errors
    !this.$v.item.neighborhood.required && errors.push('Bairro é obrigatório.')
    return errors
  },

  institutionNumberErrors () {
    const errors = []
    if (!this.$v.item.number.$dirty) return errors
    !this.$v.item.number.required && errors.push('Número é obrigatório.')
    return errors
  },


  // validações dados ats representante
  responsibleNameErrors () {
    const errors = []
    if (!this.$v.item.responsible.name.$dirty) return errors
    !this.$v.item.responsible.name.required && errors.push('Nome é obrigatório.')
    return errors
  },

  responsibleEmailErrors () {
    const errors = []
    if (!this.$v.item.responsible.email.$dirty) return errors
    !this.$v.item.responsible.email.required && errors.push('Email é obrigatório.')
    !this.$v.item.responsible.email.email && errors.push('Por favor, digitar um email válido.')
    return errors
  },

  responsibleCpfErrors () {
    const errors = []
    if (!this.$v.item.responsible.cpf.$dirty) return errors
    !this.$v.item.responsible.cpf.required && errors.push('Cpf é obrigatório.')
    return errors
  },

  responsibleAddressErrors () {
    const errors = []
    if (!this.$v.item.responsible.address.$dirty) return errors
    !this.$v.item.responsible.address.required && errors.push('Endereço é obrigatório.')
    return errors
  },

  responsiblePhoneErrors () {
    const errors = []
    if (!this.$v.item.responsible.phone.$dirty) return errors
    !this.$v.item.responsible.phone.required && errors.push('Telefone é obrigatório.')
    return errors
  },

  responsibleBusinessPhoneErrors () {
    const errors = []
    if (!this.$v.item.responsible.businessPhone.$dirty) return errors
    !this.$v.item.responsible.businessPhone.required && errors.push('Telefone Comercial é obrigatório.')
    return errors
  },

  responsibleCepErrors () {
    const errors = []
    if (!this.$v.item.responsible.cep.$dirty) return errors
    !this.$v.item.responsible.cep.required && errors.push('CEP é obrigatório.')
    !this.$v.item.responsible.cep.minLength && errors.push('Por favor, digitar um CEP Válido.')
    return errors
  },

  responsibleCityErrors () {
    const errors = []
    if (!this.$v.item.responsible.city.$dirty) return errors
    !this.$v.item.responsible.city.required && errors.push('Cidade é obrigatório.')
    return errors
  },

  responsibleStateErrors () {
    const errors = []
    if (!this.$v.item.responsible.state.$dirty) return errors
    !this.$v.item.responsible.state.required && errors.push('Estado é obrigatório.')
    return errors
  },

  responsibleNeighborhoodErrors () {
    const errors = []
    if (!this.$v.item.responsible.neighborhood.$dirty) return errors
    !this.$v.item.responsible.neighborhood.required && errors.push('Estado é obrigatório.')
    return errors
  },

  responsibleNumberErrors () {
    const errors = []
    if (!this.$v.item.responsible.number.$dirty) return errors
    !this.$v.item.responsible.number.required && errors.push('Estado é obrigatório.')
    return errors
  },
}
